import React, { useState } from 'react';
import Box from '@mui/joy/Box';
import Container from '@mui/joy/Container';
import Typography from '@mui/joy/Typography';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import { ConnectionsPanel } from '../../components/ConnectionsPanel';
import { BankingAccountsPanel } from '../../components/settings/BankingAccountsPanel';
import { BranchesPanel } from '../../components/settings/BranchesPanel';

type SettingsTab = 'connections' | 'banking' | 'branches';

const Settings: React.FC = () => {
  const [tab, setTab] = useState<SettingsTab>('connections');

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 3 }, width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography level="h2">Configuración</Typography>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value as SettingsTab)}
          sx={{
            borderBottom: '1px solid',
            borderColor: 'divider',
            '--List-paddingX': 0,
          }}
        >
          <TabList>
            <Tab value="connections">Conexiones</Tab>
            <Tab value="banking">Cuentas bancarias</Tab>
            <Tab value="branches">Sucursales</Tab>
          </TabList>
        </Tabs>
        {tab === 'connections' ? <ConnectionsPanel /> : null}
        {tab === 'banking' ? <BankingAccountsPanel /> : null}
        {tab === 'branches' ? <BranchesPanel /> : null}
      </Box>
    </Container>
  );
};

export default Settings;
